import React, { useState } from "react";
import { Package } from "lucide-react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { PurchasesTable } from "./PurchasesTable";
import { FulfillQueueModal } from "./FulfillQueueModal";

export const PurchasesView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  activeInventory,
  inventory,
  purchases,
  setInventorySubTab,
  handleNewPurchase,
  setViewItem,
  setRestockItem,
  setInitialReturnInvoice,
  setSelPR,
  setPurchaseReturnOpen,
  setEditingItem,
  setForm,
  setAddOpen,
  setPurchaseOpen,
  onExport,
  isExporting
}) => {
  const [fulfillingQueueItem, setFulfillingQueueItem] = useState(null);
  const filteredPurchases = purchases;

  const hasOpenStockMatches = search && inventory.some(i => 
    ((i.name || "").toLowerCase().includes(search.toLowerCase()) || (i.itemName || "").toLowerCase().includes(search.toLowerCase())) && 
    (i.invoiceNo === 'OPEN-STOCK' || i.supplier === 'Opening Stock')
  );

  if (filteredPurchases.length === 0 && hasOpenStockMatches) {
    return (
      <div className="card p-12 flex flex-col items-center justify-center bg-white shadow-sm border border-slate-100 rounded-2xl animate-in zoom-in-95 duration-500">
        <div className="w-16 h-16 bg-blue-50 text-brand-blue rounded-full flex items-center justify-center mb-4">
          <Package size={32} />
        </div>
        <h2 className="text-xl font-bold text-brand-dark mb-1">Found in Open Stock</h2>
        <p className="text-slate-500 text-sm mb-6 text-center max-w-md">
          No purchase records found for "{search}". However, this item has entries in the Open Stock records.
        </p>
        <button 
          onClick={() => setInventorySubTab("open_stock")}
          className="btn-primary px-8 py-2.5 text-xs font-black uppercase tracking-widest flex items-center gap-2"
        >
          View Open Stock Records
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        onAddItemClick={handleNewPurchase}
        buttonLabel="Purchase"
        showStatusFilter={false}
        showVendorFilter={true}
        showCustomerFilter={false}
        showCategoryFilter={false}
        showItemFilter={true}
        masterItems={dynamicSettings?.masterItems || inventory || []}
        onExport={onExport}
        isExporting={isExporting}
      />

      {filteredPurchases.length > 0 && hasOpenStockMatches && (
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 flex items-center justify-between gap-3 animate-in fade-in slide-in-from-top-2 duration-500">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-brand-blue rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-200">
              <Package size={16} className="text-white" />
            </div>
            <div>
              <div className="text-sm font-bold text-blue-900">Open Stock Also Available</div>
              <p className="text-[11px] text-blue-700">Records for "{search}" also exist in the Open Stock tab.</p>
            </div>
          </div>
          <button 
            onClick={() => setInventorySubTab("open_stock")}
            className="text-xs font-bold text-brand-blue hover:text-blue-800 bg-white px-4 py-2 rounded-lg border border-blue-100 shadow-sm transition-all active:scale-95"
          >
            Switch to Open Stock
          </button>
        </div>
      )}
      <PurchasesTable
        purchases={filteredPurchases}
        onView={setViewItem}
        onRestock={setRestockItem}
        onReturn={(item) => {
          setInitialReturnInvoice(item.invoiceNumber || item.invoiceNo || item.billNo || "");
          setSelPR(null);
          setPurchaseReturnOpen(true);
        }}
        onEdit={(item) => {
          setEditingItem(item);
          setForm({ ...item });
          setAddOpen(false);
          setPurchaseOpen(true);
        }}
        onFulfillQueue={(item) => setFulfillingQueueItem(item)}
        dynamicSettings={dynamicSettings}
      />
      <FulfillQueueModal
        isOpen={Boolean(fulfillingQueueItem)}
        item={fulfillingQueueItem}
        onClose={() => setFulfillingQueueItem(null)}
        onSuccess={() => {
          setFulfillingQueueItem(null);
          window.location.reload();
        }}
      />
    </div>
  );
};

